function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 19.2652L5.47639 6.92607C4.22318 5.69131 2.19313 5.69131 0.939914 6.92607C-0.313305 8.16082 -0.313305 10.161 0.939914 11.3957L11.1931 21.4979L13.4635 19.2652C14.7167 18.0304 16.7468 18.0304 18 19.2652ZM15.7296 24.6609C14.9099 24.6609 14.0901 24.3522 13.4635 23.7348L11.1931 21.4979L0.939914 31.6043C-0.313305 32.839 -0.313305 34.8392 0.939914 36.0739C1.56652 36.6913 2.38627 37 3.20601 37C4.03004 37 4.84979 36.6913 5.47639 36.0739L18 23.7348C17.3734 24.3522 16.5536 24.6609 15.7296 24.6609Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5089 25C16.3267 25 17.1446 24.6584 17.7655 23.9753C19.0115 22.6091 19.0115 20.3909 17.7655 19.0247C16.5194 17.6584 14.5026 17.6584 13.2566 19.0247L11 21.5021L13.2566 23.9753C13.8775 24.6584 14.6953 25 15.5089 25Z",
  fill: "#CFDCE7"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.566 26.1203L6.94707 38.5602C5.68431 39.8051 5.68431 41.8215 6.94707 43.0664C7.57845 43.6888 8.40443 44 9.23041 44C10.0607 44 10.8867 43.6888 11.5181 43.0664L21.8537 32.8774L19.566 30.6265C18.3032 29.3816 18.3032 27.3652 19.566 26.1203ZM24.137 26.1203C25.3998 27.3652 25.3998 29.3816 24.137 30.6265L21.8493 32.8774L25.4819 36.4542C26.1133 37.0766 26.9393 37.3878 27.7653 37.3878C28.5912 37.3878 29.4216 37.0766 30.0529 36.4542C31.3157 35.2094 31.3157 33.1929 30.0529 31.9481L24.137 26.1203ZM19.566 17.8797C18.3032 16.6348 18.3032 14.6184 19.566 13.3735L21.8537 11.1183L11.5181 0.93363C10.2553 -0.31121 8.20983 -0.31121 6.94707 0.93363C5.68431 2.17847 5.68431 4.19494 6.94707 5.43978L19.566 17.8797ZM24.137 17.8797L30.0529 12.0477C31.3157 10.8028 31.3157 8.78636 30.0529 7.54152C28.7902 6.29668 26.7447 6.29668 25.4819 7.54152L21.8493 11.1183L24.137 13.3735C25.3998 14.6184 25.3998 16.6348 24.137 17.8797Z",
  fill: "#6DD400"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.376 17.711C20.0602 18.3266 20.9546 18.6364 21.8491 18.6364C22.7435 18.6364 23.6421 18.3266 24.3264 17.711C25.6907 16.4718 25.6907 14.4722 24.3264 13.237L21.8491 11L19.376 13.237C18.0075 14.4722 18.0075 16.4718 19.376 17.711ZM19.376 26.2754C20.0602 25.6598 20.9546 25.35 21.8491 25.35C22.7435 25.35 23.6421 25.6598 24.3264 26.2754C25.6907 27.5146 25.6907 29.5142 24.3264 30.7494L21.8491 32.9864L19.376 30.7494C18.0075 29.5142 18.0075 27.5146 19.376 26.2754Z",
  fill: "#5FB800"
});

var SvgLogoSmall = function SvgLogoSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 44,
    viewBox: "0 0 31 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-small.5f816e37.svg";
export { ForwardRef as ReactComponent };